const breadcrumbs = {
  datasets: {
    label: "Datasets",
    path: "/datasets",
    children: {
      ":datasetId": {
        label: (params, data) =>
          data?.datasets?.[params.datasetId]?.name || "Dataset",
        children: {
          schemas: {
            children: {
              create: {
                label: "Create Schema",
              },
              ":schemaId": {
                label: (params, data) =>
                  data?.schemas?.[params.schemaId]?.name || "Schema",
                children: {
                  records: {
                    label: "Records",
                  },
                  permissions: {
                    label: "Permissions",
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  account: { label: "Account" },
  profile: { label: "Profile" },
  identities: { label: "Identities" },
  requests: { label: "Requests" },
  materials: { label: "Materials" },
  users: { label: "Users" },
  devtest: {
    label: "DevTest",
    children: {
      tables: { label: "Tables" },
      alerts: { label: "Alerts" },
      buttons: { label: "Buttons" },
      responsiveStyles: { label: "Responsive Styles" },
    },
  },
}

export default breadcrumbs
